export const SPACING_0 = 0;
export const SPACING_1 = 1;
export const SPACING_2 = 2;
export const SPACING_3 = 3;
export const SPACING_4 = 4;
export const SPACING_5 = 5;
export const SPACING_6 = 6;
